import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Projects`}</h2>
    <ProjectCard title="Personalized Spotify App" link="https://personalizedspotify1.herokuapp.com" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
A web app for visualizing personalized Spotify data. View your top artists, top tracks, recently played tracks, and detailed audio information about each track. Create and save new playlists of recommended tracks based on your existing playlists and more.<br />
Used Spotify Web API, Create React App, Express, Reach Router, Styled Components<br />
    </ProjectCard>
    <ProjectCard title="Virtual cook" link="https://github.com/Shubhampreet98/The-Virtual-Cook" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
A user interactive Web based smart recipe search engine in Flask framework with jQuery and Ajax which allows users to search dishes on based of ingredients and dish’s name, user can post comments or reviews about their dishes on this platform.<br />
* Authenticated and secure login system.<br />
Includes user’s personal information update system.<br />
Developed MySQL database for dishes.<br />
Used HTML, CSS, Python, Flask, MySQL, SQLAlchemy, Ajax, jQuery, Bootstrap, phpMyAdmin etc.
    </ProjectCard>
    <ProjectCard title="Galagram Events" link="https://www.galagramevents.com/" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
An Event Management start-up by me and my friends that organize and plan small to mid-size events and parties in Edmonton and nearby areas.<br />
Built Company website, appointment, and booking system for clients.
      <br />
    </ProjectCard>
    <ProjectCard title="SMIS database" link="https://github.com/Shubhampreet98" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
Designed and Implemented relational database for Student management Information System (SMIS).<br />
Developed conceptual structure and logical design for SMIS system which includes design goals,
principles, steps, and descriptions of relationships followed by ERD diagrams.<br />
Implemented the design in MySQL using SQL DDL and SQL DQL results in fully developed database
system for Students Management Information System.<br />
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      